export default function Selectbox({ options, selected, onChange }) {
  return (
    <div className="w-full h-[35px] flex items-center rounded-full border border-gray-300">
      {options.map((tab, idx) => (
        <button
          key={idx}
          onClick={() => onChange(tab)}
          className={`w-1/2 h-[35px] p-[7.5px] p-2.5 text-sm cursor-pointer leading-[20px] tracking-[0%] text-center flex items-center justify-center ${
            selected === tab
              ? 'rounded-full border-2 text-[#07276B] border-[#07276B] font-semibold'
              : ' text-[#A4A7AE] font-light'
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
